export default "__VITE_ASSET__CXzskldL__"